import type {
  KlardatenInstance,
  KlardatenProfile,
} from '../api/klardaten-credentials';

function asString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

export function getKlardatenInstanceLabel(instance: KlardatenInstance): string {
  const name = asString(instance.name);
  const consultantNumber = asString(instance.consultant_number);
  const id = asString(instance.id) ?? 'Unknown';
  if (name && consultantNumber) return `${name} (${consultantNumber})`;
  return name ?? id;
}

export function getKlardatenProfilePrimaryLabel(
  profile: KlardatenProfile
): string {
  const label =
    asString(profile.name) ?? asString(profile.profile_id) ?? 'Profile';
  return profile.is_default ? `${label} (API default)` : label;
}

export function getKlardatenProfileSecondaryLabel(
  profile: KlardatenProfile
): string {
  const profileId = asString(profile.profile_id) ?? 'unknown';
  const scope =
    profile.scope === 'organization' ? 'Organization profile' : 'User profile';
  return `${scope} · ${profileId}`;
}
